import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { bisect } from 'd3-array';

var DiscreteScale =
/*#__PURE__*/
function () {
  function DiscreteScale() {
    var _this = this;

    _classCallCheck(this, DiscreteScale);

    _defineProperty(this, "getValue", function (x) {
      var range = _this.range,
          domain = _this.domain,
          n = _this.n;
      return range[bisect(domain, x, 0, n)];
    });

    _defineProperty(this, "setDomain", function (val) {
      _this.x0 = +val[0];
      _this.x1 = +val[1];

      _this.rescale();

      return _this;
    });

    _defineProperty(this, "setRange", function (val) {
      _this.range = val.slice();
      _this.n = _this.range.length - 1;
      return _this;
    });

    this.x0 = 0;
    this.x1 = 1;
    this.domain = [0.5];
    this.range = [0, 1];
    this.n = 1;
  }

  _createClass(DiscreteScale, [{
    key: "rescale",
    value: function rescale() {
      var x0 = this.x0,
          x1 = this.x1,
          n = this.n;
      var i = -1;
      this.domain = new Array(n);

      while (++i < n) {
        this.domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
      }
    }
  }]);

  return DiscreteScale;
}();

export default DiscreteScale;